export default __webpack_public_path__ + "static/media/portfolio-39-small.17c229e6.jpg";